module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.96c4768.eot";